var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guidepage"},[_c('img',{staticClass:"img",attrs:{"src":_vm.guidePageImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }